import * as ponyfill from 'web-streams-polyfill/ponyfill';
import streamSaver from 'streamsaver';
import {serviceWorkerSupported} from '../utils';

// Use self hosted `mitm.html` & `sw.js`.
// https://github.com/jimmywarting/StreamSaver.js#configuration
streamSaver.mitm = 'streamsaver/mitm.html';

// Add ponyfill to support more browsers.
// https://github.com/jimmywarting/StreamSaver.js/issues/109#issuecomment-673101938
streamSaver.WritableStream = ponyfill.WritableStream;


export default class FileDigester {


  constructor(meta, callback) {
    this.meta = {
      size: 0,
      mime: 'application/octet-stream',
      name: '',
      ...meta
    };
    this.completed = false;
    this.bytesReceived = 0;

    if (!serviceWorkerSupported) {
      this._buffer = [];

    } else {
      const {name, size} = this.meta;
      const fileStream = streamSaver.createWriteStream(name, {size});
      this._writer = fileStream.getWriter();
    }

    this._callback = callback;
  }


  get progress() {
    return this.bytesReceived / this.meta.size;
  }


  unchunk(chunk) {
    if (this.completed) {
      return;
    }

    if (this._buffer) {
      this._buffer.push(chunk);

    } else if (this._writer) {
      // https://github.com/jimmywarting/StreamSaver.js/issues/180#issuecomment-699391826
      this._writer.write(new Uint8Array(chunk));
    }

    this.bytesReceived += chunk.byteLength || chunk.size;

    if (this.bytesReceived >= this.meta.size) {
      this.completed = true;

      if (this._buffer) {
        const blob = new Blob(this._buffer, {type: this.meta.mime});
        this._callback({...this.meta, blob});

      } else if (this._writer) {
        this._writer.close();
        this._callback(this.meta);
      }
    }
  }


  cancel() {
    if (this.completed) {
      return;
    }

    this.completed = true;
    if (this._writer) {
      this._writer.abort();
    }
  }
}
